import { useAccountDetails } from "@/crud/account/hooks";
import { SoftwareAliasContextProvider } from "@/crud/software/context";
import { useSoftwareAlias } from "@/crud/software/hooks";
import { AliasView } from "@/pages/Software/SoftwareEnvironment/alias";
import { SoftwareBuildView } from "@/pages/Software/SoftwareEnvironment/build";
import { LoadingScreen } from "@/shared-components/LoadingScreen";
import { WorkspaceContextProvider } from "@/utils/context";
import { Stack } from "@mui/material";
import React from "react";
import { Route, Routes, useParams } from "react-router-dom";

const AliasScopedRoutes = (): React.ReactElement => {
  const aliasId = parseInt(useParams().aliasId as string, 10);
  const { data: alias, isSuccess } = useSoftwareAlias(aliasId);
  return (
    <Stack spacing={2} direction="column">
      {!isSuccess && <LoadingScreen />}
      {isSuccess && (
        <SoftwareAliasContextProvider alias={alias}>
          <Routes>
            <Route path="/" element={<AliasView />} />
            <Route path="/build/:buildId" element={<SoftwareBuildView />} />
          </Routes>
        </SoftwareAliasContextProvider>
      )}
    </Stack>
  );
};
export const SoftwareEnvironmentView = (): React.ReactElement => {
  const accountSlug = useParams().accountSlug as string;
  const { data: workspace, isSuccess: workspaceLoaded } = useAccountDetails({
    workspaceSlug: accountSlug,
  });
  return (
    <Stack spacing={2} direction="column">
      {!workspaceLoaded && <LoadingScreen />}
      {workspaceLoaded && (
        <WorkspaceContextProvider workspace={workspace}>
          <AliasScopedRoutes />
        </WorkspaceContextProvider>
      )}
    </Stack>
  );
};
